/**
 * Signals that make the worklist refresh itself when report status changes
 * elsewhere in the app (delete draft, sign, save first draft).
 *
 * Two channels because a plain localStorage `storage` event only fires in
 * OTHER tabs — never in the tab that wrote it. So we also fire a same-tab
 * CustomEvent for the case where ReportEditor and WorklistPage are in the
 * same tab (SPA nav).
 */

export const WORKLIST_REFRESH_EVENT = 'edgeweb:worklist-refresh';

/** Called by ReportEditor after any status change (save/sign/delete). */
export function broadcastReportChanged() {
  try { localStorage.setItem('edgeweb-worklist-refresh', String(Date.now())); } catch {}
  try { window.dispatchEvent(new CustomEvent(WORKLIST_REFRESH_EVENT)); } catch {}
}

/** WorklistPage hook. `handler` is called on any report status change. */
export function subscribeToReportChanges(handler: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === 'edgeweb-worklist-refresh' || (e.key || '').startsWith('edgeweb-report-status-')) {
      handler();
    }
  };
  const onCustom = () => handler();
  window.addEventListener('storage', onStorage);
  window.addEventListener(WORKLIST_REFRESH_EVENT, onCustom);
  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(WORKLIST_REFRESH_EVENT, onCustom);
  };
}
